import countries, {ICountry, countryNone} from './countries';
import {PhoneNumberUtil} from 'google-libphonenumber';
import {GlobeIcon} from '../../component/icons';

export function getSelectedCountry(phoneUtil: PhoneNumberUtil, phoneNumber: string, defaultCountryOnNew: string = ''): ICountry {
    if (phoneNumber) {
        try {
            const parsedPhoneNumber = phoneUtil.parse(phoneNumber);
            if (parsedPhoneNumber && parsedPhoneNumber.getCountryCode()) {
                const countryCallingCode = '+' + parsedPhoneNumber.getCountryCode().toString();
                const foundCountries = countries.filter(x => x.callingCode.toLowerCase().indexOf(countryCallingCode.toLowerCase()) !== -1);
                let foundCountry: ICountry;
                if (foundCountries.length > 1) {
                    const sortedCountries = foundCountries.sort((a, b) => {
                        const aHasAreaCodes = a.areaCodes !== undefined && a.areaCodes.length > 0;
                        const bHasAreaCodes = b.areaCodes !== undefined && b.areaCodes.length > 0;
                        if (aHasAreaCodes && !bHasAreaCodes) {
                            return -1;
                        } else if (bHasAreaCodes && !aHasAreaCodes) {
                            return 1;
                        } else if (aHasAreaCodes && bHasAreaCodes) {
                            return a.areaCodes.length > b.areaCodes.length ? -1 : (a.areaCodes.length === b.areaCodes.length ? 0 : 1);
                        }
                        return a.callingCode.length > b.callingCode.length ? -1 : (a.callingCode.length === b.callingCode.length ? 0 : 1);
                    });
                    foundCountry = sortedCountries.find((c) => {
                        let searchList: string[];
                        if (c.areaCodes) {
                            searchList = [];
                            c.areaCodes.forEach(code => {
                                searchList.push(c.callingCode + code);
                            });
                        } else {
                            searchList = [c.callingCode];
                        }
                        for (const item of searchList) {
                            if (phoneNumber.indexOf(item) === 0) {
                                return true;
                            }
                        }
                    });
                } else if (foundCountries.length > 0) {
                    foundCountry = foundCountries[0];
                } else {
                    const countryCode = phoneUtil.getRegionCodeForCountryCode(parsedPhoneNumber.getCountryCode());
                    foundCountry = {
                        icon: GlobeIcon,
                        callingCode: countryCallingCode,
                        countryCode: countryCode,
                        name: countryCode,
                    };
                }
                if (foundCountry) {
                    return foundCountry;
                }
            }
        } catch {
            return countryNone;
        }
    }
    if (defaultCountryOnNew) {
        const defaultOnNew = countries.find(x => x.countryCode.toLowerCase() === defaultCountryOnNew.toLowerCase());
        if (defaultOnNew) {
            return defaultOnNew;
        }
    }
    return countryNone;
}
